import { render, staticRenderFns } from "./CargaPrioridadArticulos.vue?vue&type=template&id=f0ece22e&"
import script from "./CargaPrioridadArticulos.vue?vue&type=script&lang=js&"
export * from "./CargaPrioridadArticulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports